/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Event_Group_Sync_Status_ProgressInputs */



/**
* | output |
* | --- |
* | "Syncing event {current}/{total}" |
*
* @param {Event_Group_Sync_Status_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_status_progress = /** @type {((inputs: Event_Group_Sync_Status_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Status_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
});